import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  changePasswordError: null,
  isPasswordSaving: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordError: getErrorMessage(action.payload),
        isPasswordSaving: false,
      };
    case types.CHANGE_PASSWORD_INIT:
      return {
        ...initialState,
      };
    case types.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePasswordError: null,
        isPasswordSaving: true,
      };
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isPasswordSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.userProfile.changePassword;

export const getChangePasswordError = (state) =>
  getScope(state).changePasswordError;

export const isPasswordSaving = (state) => getScope(state).isPasswordSaving;
